import React from 'react';
import { autoId } from '../../utils/AutomationUtil';
import styles from './SignOut.module.scss';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import { ID_CONTINUE_BUTTON } from '../../autoIds';

interface SignOutProps {
    onSignInClick?: () => void;
    textProps: SignOutTextProps;
}

interface SignOutTextProps {
    header: string;
    description: string;
    signInButtonText: string;
}

export function SignOut({ onSignInClick, textProps, ...rest }: SignOutProps) {
    return (
        <div className={styles.container} {...rest}>
            <h2 className={styles.heading}>{textProps.header}</h2>
            <p className={styles.text}>{textProps.description}</p>
            {onSignInClick && (
                <PrimaryButton
                    {...autoId(ID_CONTINUE_BUTTON)}
                    size='large'
                    onClick={onSignInClick}
                    className={styles.button}>
                    {textProps.signInButtonText}
                </PrimaryButton>
            )}
        </div>
    );
}
